import React, { useState, useCallback } from 'react';
import { Layout, Model, Actions, DragActionsLayout } from 'flexlayout-react';
import { Box } from '@mui/material';
import 'flexlayout-react/style/dark.css';
import '../../styles/custom-flexlayout-styles.css';

const FlexibleLayout = ({ components }) => {
    const [model, setModel] = useState(() => {
        const initialModel = {
            global: {},
            layout: {
                type: 'row',
                weight: 100,
                children: [
                    {
                        type: 'tabset',
                        weight: 22,
                        children: [
                            {
                                type: 'tab',
                                name: 'Transcript',
                                component: 'transcriptViewer',
                            },
                            {
                                type: 'tab',
                                name: 'Subtitles',
                                component: 'subtitleManager',
                            },
                        ],
                    },
                    {
                        type: 'row',
                        weight: 70,
                        children: [
                            {
                                type: 'row',
                                weight: 75,
                                children: [
                                    {
                                        type: 'tabset',
                                        weight: 35,
                                        children: [
                                            {
                                                type: 'tab',
                                                name: 'Reference Files',
                                                component: 'referenceManager',
                                            },
                                            {
                                                type: 'tab',
                                                name: 'Lip Sync',
                                                component: 'lipSyncManager',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'tabset',
                                        weight: 70,
                                        children: [
                                            {
                                                type: 'tab',
                                                name: 'Video Player',
                                                component: 'videoPlayer',
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                type: 'row',
                                weight: 55,
                                children: [
                                    {
                                        type: 'tabset',
                                        weight: 75,
                                        children: [
                                            {
                                                type: 'tab',
                                                name: 'Timeline',
                                                component: 'timeline',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'tabset',
                                        weight: 10,
                                        children: [
                                            {
                                                type: 'tab',
                                                name: '', // ✅ Nom vide pour masquer le titre
                                                component: 'volumeWidget',
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        };
        return Model.fromJson(initialModel);
    });

    const factory = (node) => {
        const component = node.getComponent();
        return components[component];
    };

    const onModelChange = useCallback((newModel) => {
        setModel(newModel);
    }, []);

    return (
        <Box sx={{ height: '100%', overflow: 'hidden' }}>
            <Layout
                model={model}
                factory={factory}
                onModelChange={onModelChange}
                actions={Actions}
                dragActions={DragActionsLayout}
            />
        </Box>
    );
};

export default FlexibleLayout;